<template>
    <el-dialog
        @close="closeCb"
        title="修改密码"
        :close-on-click-modal="false"
        :show-close="showClose"
        :visible.sync="isVisible"
        class="leader-dialog"
    >
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="原密码" label-width="100px"  prop="old_password">
                <!-- :type="oldStatus ? 'text':'password'" -->
                <el-input
                    type="text"
                    :class="oldStatus ? '':'disguising-password'"
                    v-model="form.old_password"
                    autocomplete="new-password"
                >
                    <el-button @click="changePwdType('old')" slot="append">
                        <i
                            :class="['iconfont',{'icon-yanjing_kai':!oldStatus},{'icon-yanjing':oldStatus} ]"
                        ></i>
                    </el-button>
                </el-input>
            </el-form-item>
            <el-form-item label="新密码" label-width="100px" prop="password1">
                <!-- :type="newStatus ? 'text':'password'" -->
                <el-input
                    type="text"
                    :class="newStatus ? '':'disguising-password'"
                    v-model="form.password1"
                    autocomplete="new-password"
                >
                    <el-button @click="changePwdType('new')" slot="append">
                        <i
                            :class="['iconfont',{'icon-yanjing_kai':!newStatus},{'icon-yanjing':newStatus} ]"
                        ></i>
                    </el-button>
                </el-input>
            </el-form-item>
            <el-form-item label="确认密码" label-width="100px" prop="password2">
                <!-- :type="reStatus ? 'text':'password'" -->
                <el-input
                    type="text"
                    :class="reStatus ? '':'disguising-password'"
                    v-model="form.password2"
                    autocomplete="new-password"
                >
                    <el-button @click="changePwdType('re')" slot="append">
                        <i
                            :class="['iconfont',{'icon-yanjing_kai':!reStatus},{'icon-yanjing':reStatus} ]"
                        ></i>
                    </el-button>
                </el-input>
            </el-form-item>     
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="cancle-class"  style="background: #dddddd;color: #333333 !important;" @click="isVisible = false">取 消</el-button>
            <el-button class="submit-class"  @click="resetPwd">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { closeWebsocket } from '@/utils/websocket.js'
import { updatePassword } from "@/http/api.js";
export default {
    data() {
        const validatePassowrd = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("*请输入密码"));
            } else {
                if (
                    this.form.password2 !== undefined &&
                    this.form.password2 !== ""
                ) {
                    this.$refs.form.validateField("password2");
                }
                callback();
            }
        };
        const validateRPass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("*请再次输入密码"));
            } else if (value !== this.form.password1) {
                callback(new Error("*两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            form: {
                old_password: "",
                password1: "",
                password2: ""
            },
            rules: {
                old_password: [
                    {
                        required: true,
                        message: "请填写原密码",
                        trigger: "blur"
                    }
                ],
                password1: [
                    {
                        required: true,
                        message: "请填写新密码",
                        trigger: "blur"
                    },
                    { validator: validatePassowrd, trigger: "blur" }
                ],
                password2: [
                    {
                        required: true,
                        message: "请填写确认密码",
                        trigger: "blur"
                    },
                    { validator: validateRPass, trigger: "blur" }
                ]
            },
            oldStatus: false,
            newStatus: false,
            reStatus: false
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.login.userInfo;
        }
    },
    watch: {
        userInfo() {
            return this.$store.state.login.userInfo;
        }
    },
    props: {
        isVisible: {
            type: Boolean,
            default: true
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        changePwdType(type) {
            if (type === "old") {
                this.oldStatus = !this.oldStatus;
            } else if (type === "new") {
                this.newStatus = !this.newStatus;
            } else {
                this.reStatus = !this.reStatus;
            }
        },
        /**
         * 重置密码
         */
        resetPwd() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    updatePassword({
                        ...this.form,
                        user_id: this.userInfo.user_id
                    }).then(res => {
                        if (res && res.error_code == "0") {
                            if (this.showClose) {
                                this.$message({
                                    message:
                                        "恭喜你，修改成功，正在跳转到登录页面.....",
                                    type: "success"
                                });
                                sessionStorage.clear();
                                this.closeCb();
                                setTimeout(() => {
                                    this.$router.push("/login");
                                    closeWebsocket();
                                }, 1000);
                            } else {
                                this.$message({
                                    message: "修改成功!",
                                    type: "success"
                                });
                                sessionStorage.clear();
                                this.closeCb();
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        closeCb() {
            this.$refs["form"].resetFields();
            this.$refs["form"].clearValidate();
            this.isVisible = false;
            this.$emit("update:isVisible", this.isVisible);
        }
    }
};
</script>
<style lang="scss">
    .top span{
        position: inherit !important;
       
    }
    .cancle-class{
        span{
            color: #333333 !important;
            font-weight:normal !important;
        }
    }
    .submit-class{
        background: #0b1929;
        border: 1px solid #56fcff; 
        span{
            font-weight:normal !important;
        }
    }
    .el-form-item__label{
        color: #FFFFFF;
    }
</style>